import { configuration } from '../../../../../app/common-reducers.js';
import { disableFacet, enableFacet, updateFacetOptions, } from '../../../../../features/facet-options/facet-options-actions.js';
import { isFacetEnabledSelector } from '../../../../../features/facet-options/facet-options-selectors.js';
import { facetOptionsReducer as facetOptions } from '../../../../../features/facet-options/facet-options-slice.js';
import { isFacetLoadingResponseSelector } from '../../../../../features/facets/facet-set/facet-set-selectors.js';
import { registerDateFacet, updateDateFacetValues, } from '../../../../../features/facets/range-facets/date-facet-set/date-facet-actions.js';
import { dateFacetSelectedValuesSelector } from '../../../../../features/facets/range-facets/date-facet-set/date-facet-selectors.js';
import { dateFacetSetReducer as dateFacetSet } from '../../../../../features/facets/range-facets/date-facet-set/date-facet-set-slice.js';
import { searchReducer as search } from '../../../../../features/search/search-slice.js';
import { selectActiveTab } from '../../../../../features/tab-set/tab-set-selectors.js';
import { loadReducerError } from '../../../../../utils/errors.js';
import { buildController, } from '../../../../controller/headless-controller.js';
import { determineFacetId } from '../../_common/facet-id-determinor.js';
import { validateDateFacetOptions } from './headless-date-facet-options.js';
export function buildCoreDateFilter(engine, props) {
    if (!loadDateFilterReducer(engine)) {
        throw loadReducerError;
    }
    const controller = buildController(engine);
    const { dispatch } = engine;
    const getState = () => engine.state;
    const facetId = determineFacetId(engine, props.options);
    const tabs = props.options.tabs ?? {};
    const activeTab = selectActiveTab(engine.state.tabSet);
    const options = {
        ...props.options,
        currentValues: props.initialState?.range
            ? [{ ...props.initialState.range, endInclusive: true, state: 'selected' }]
            : [],
        generateAutomaticRanges: false,
        facetId,
        tabs,
        activeTab,
    };
    validateDateFacetOptions(engine, options);
    dispatch(registerDateFacet(options));
    const getIsEnabled = () => isFacetEnabledSelector(engine.state, facetId);
    return {
        ...controller,
        clear: () => {
            dispatch(updateDateFacetValues({
                facetId,
                values: [],
            }));
            dispatch(updateFacetOptions());
        },
        setRange: (range) => {
            const facetValue = {
                ...range,
                state: 'selected',
                numberOfResults: 0,
                endInclusive: true,
            };
            const updateFacetValuesAction = updateDateFacetValues({
                facetId,
                values: [facetValue],
            });
            if (updateFacetValuesAction.error) {
                return false;
            }
            dispatch(updateFacetValuesAction);
            dispatch(updateFacetOptions());
            return true;
        },
        enable() {
            dispatch(enableFacet(facetId));
        },
        disable() {
            dispatch(disableFacet(facetId));
        },
        get state() {
            const isLoading = isFacetLoadingResponseSelector(getState());
            const enabled = getIsEnabled();
            const selectedRanges = dateFacetSelectedValuesSelector(getState(), facetId);
            const range = selectedRanges.length ? selectedRanges[0] : undefined;
            return {
                facetId,
                isLoading,
                range,
                enabled,
            };
        },
    };
}
function loadDateFilterReducer(engine) {
    engine.addReducers({ dateFacetSet, facetOptions, configuration, search });
    return true;
}
